import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Modal from '../../../shared/Modals/Modal';
import TextFieldInput from '../../../shared/Inputs/TextField';
import classnames from 'classnames';
import { Formik, Field } from 'formik';
import ProgressButton from '../../../shared/Buttons/ProgressButton';
import GridItem from '../../../shared/GridItem';
import combineStyles from '../../../../helpers/combineStyles';
import LayoutStyles from '../../../../styles/layout';
import TypographyStyles from '../../../../styles/typography';
import ButtonStyles from '../../../../styles/button';
import SpacingStyles from '../../../../styles/helpers/spacing';
import _forEach from 'lodash/forEach';
import { filterListFuzzyly } from '../../../../helpers/utilityFunctions';
import FormValidation from './Form.validation';
import SimpleSelect from '../../../shared/Selects/SimpleSelect';
import ChippedAutocompleteInput from '../../../shared/Inputs/ChippedAutocomplete';
import {
  Grid,
  FormControlLabel,
  Checkbox,
  Button
} from '@material-ui/core';
import { globalSettingTypes } from '../TableMetadata';
import { GlobalSettingType } from '../../../../constants/enums';

const styles = theme => ({
  titleWrapper: {
    display: 'flex',
    marginBottom: `${theme.spacing.unit * 2.125}px !important`,
    position: 'relative'
  },
  title: {
    flex: 1,
    fontWeight: 'bold !important'
  },
  resetLinkButton: {
    position: 'absolute',
    right: 0,
    top: -6
  },
  resetLink: {
    textTransform: 'capitalize',
    color: `${theme.palette.primary.main} !important`
  },
  modalFooter: {
    marginTop: `${theme.spacing.unit * 5}px !important`
  },
  centerBox: { 
    display: 'flex',
    alignItems: 'center'
  }
});

export class FormModal extends Component {
  state = {
    tag: []
  };

  _handleOnClose = () => {
    const { onClose } = this.props;
    onClose();
  };

  componentDidUpdate(prevProps) {
    if (prevProps.erros !== this.props.errors) {
      const formik = this.formik;
      formik.setErrors(this._handleErrors(this.props.errors));
    }
  }

  _handleOnSave = async item => {
    const { onSave } = this.props;

    onSave(item);
  };

  _getSuggestions = async (type, value) => {
    const items = this.props[type].map(item => ({
      label: item.name || item.description || item.code,
      value: item.id
    }));

    const suggestions = filterListFuzzyly(value, items, 'label');

    return Promise.resolve(suggestions);
  };

  _handleErrors = apiErrors => {
    const errors = {};
    _forEach(apiErrors, (v, k) => (errors[k] = v[0]));
    return errors;
  };

  _getFieldType = (field, form, values, handleChange) => {
    if (values.code == "company_name") {
      return (
        <SimpleSelect
          label="Valor"
          field={field}
          form={form}
          name="value"
          options={this.props.itemList}
          value={values.value}
          fullWidth
          onChange={handleChange}
          margin="normal"
          variant="outlined"
        />
      )
    }
    if (values.settingType == GlobalSettingType.Boolean) {
      return (
        <SimpleSelect
          label="Valor"
          field={field}
          form={form}
          name="value"
          options={[
            { key: 1, label: 'Verdadero', value: 1 },
            { key: 2, label: 'Falso', value: 0 }
          ]}
          value={values.value}
          fullWidth
          onChange={handleChange}
          margin="normal"
          variant="outlined"
        />
      )
    } else {
      return (
        <TextFieldInput
          value={values.value}
          label={'Valor'}
          fullWidth
          field={field}
          form={form}
          type={values.settingType == GlobalSettingType.Integer ? 'number' : 'text'}
        />
      )
    }
  }
  
  render() {
    const { classes, open = true, isSubmitting, item = {} } = this.props;
    return (
      <Formik
        ref={ref => (this.formik = ref)}
        enableReinitialize={true}
        validationSchema={FormValidation}
        initialValues={{
          ...item
        }}
        onSubmit={values => {
          this._handleOnSave(values);
        }}
        onReset={(values, actions) => {
          actions.resetForm();
          this._handleOnClose();
        }}
        validateOnChange={false}
        validateOnBlur={false}
        render={({
          values,
          handleChange,
          handleSubmit,
          handleReset,
          dirty
        }) => (
          <Modal
            open={open}
            onClose={this._handleOnClose}
            classes={{
              footer: classes.modalFooter
            }}
            body={
              <Fragment>
                <div className={classes.titleWrapper}>
                  <p className={classnames(classes.headline6, classes.title)}>
                    Editar Parámetro Global
                  </p>
                  </div>
                  <Grid container spacing={16}>
                    <GridItem xs={12}>
                      <Field
                        name="name"
                        onChange={handleChange}
                        render={({ field, form }) => {
                          return (
                            <TextFieldInput
                              value={values.name}
                              label={'Nombre'}
                              fullWidth
                              field={field}
                              form={form}
                            />
                          );
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12}>
                      <Field
                        name="description"
                        onChange={handleChange}
                        render={({ field, form }) => {
                          return (
                            <TextFieldInput
                              value={values.description}
                              label={'Descripción'}
                              fullWidth
                              field={field}
                              form={form}
                            />
                          );
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12}>
                      <Field
                        name="code"
                        onChange={handleChange}
                        render={({ field, form }) => {
                          return (
                            <TextFieldInput
                              value={values.code}
                              label={'Código'}
                              fullWidth
                              field={field}
                              form={form}
                              disabled
                            />
                          );
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12}>
                      <Field
                        name="value"
                        onChange={handleChange}
                        render={({ field, form }) => {
                          return this._getFieldType(field, form, values, handleChange)
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12}>
                      <Field
                        name="tags"
                        onChange={handleChange}
                        render={({ field, form }) => {
                          return (
                            <ChippedAutocompleteInput
                              getSuggestions={value =>
                                this._getSuggestions('tags', value)
                              }
                              values={values.tags ? values.tags.map((tag) => { return { label: tag.label ? tag.label : tag }; }) : []}
                              onChange={evt => {
                                const copyEvt = { ...evt };
                                const {
                                  target: { value }
                                } = evt;
                                this.setState({ tag: value });
                                copyEvt.target = { value: value, name: 'tags' };
                                handleChange(copyEvt);
                              }}
                              field={field}
                              form={form}
                              label={'Etiquetas'}
                              readOnly
                            />
                          );
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6}>
                      <Field
                        name="settingType"
                        onChange={handleChange}
                        className={classes.noMarginTop}
                        render={({ field, form }) => {
                          return (
                            <SimpleSelect
                              allowMargin={false}
                              value={values.settingType}
                              label="Tipo"
                              options={globalSettingTypes}
                              fullWidth
                              field={field}
                              form={form}
                              disabled
                              onChange={evt => {
                                const copyEvt = { ...evt };
                                const {
                                  target: { value }
                                } = evt;
                                this.setState({ settingType: value });
                                copyEvt.target = { value: value, name: 'settingType' };
                                handleChange(copyEvt);
                              }}
                            />
                          );
                        }}
                      />
                    </GridItem>
                  </Grid>
                </Fragment>
              }
              footer={
                <Fragment>
                  <div className={classes.spacer} />
                  <Button
                    className={classes.button}
                    onClick={handleReset}
                    color={'secondary'}
                    classes={{ label: classes.buttonLabel }}
                  >
                    {'Cancelar'}
                  </Button>
                  <ProgressButton
                    onClick={handleSubmit}
                    className={classes.button}
                    classes={{
                      disabled: classes.buttonDisabled,
                      label: classes.buttonLabel
                    }}
                    color={'secondary'}
                    disabled={!dirty || isSubmitting}
                    isSubmitting={isSubmitting}
                  >
                    {'Guardar'}
                  </ProgressButton>
                </Fragment>
              }
            />
          )}
      />
    );
  }
}
export default withStyles(
  combineStyles(
    styles,
    LayoutStyles,
    TypographyStyles,
    ButtonStyles,
    SpacingStyles
  )
)(FormModal);
